import { Option, Row, Trigger } from "./models";
import { matchesType } from "./type-match.utils";

export function matchesTableSelectionTrigger(rows: Row[], trigger: Trigger): boolean {
  const columnKey = trigger.columnKey || trigger.fieldKey;
  return (
    rows?.some((row) => {
      const columns = row?.columns;
      if (!columns) {
        return false;
      }
      if (
        trigger.selectedRowKey &&
        !columns.some(
          (column) =>
            matchesType(column?.type, "CountryColumn") &&
            column.countryAnswers?.some(
              (country) => (country?.countryId ?? country?.CountryId) === trigger.selectedRowKey
            )
        )
      ) {
        return false;
      }
      if (columnKey) {
        return (
          columns
            .find((column) => column?.key === columnKey)
            ?.choiceAnswers?.some(
              (option) => (option?.key ?? (option as Option & { Key?: string })?.Key) === trigger.selectedOptionKey
            ) ?? false
        );
      }
      if (trigger.selectedRowKey) {
        return false;
      }
      return columns.some((column) =>
        matchesType(column?.type, "CountryColumn")
          ? column.countryAnswers?.some(
              (country) => (country?.countryId ?? country?.CountryId) === trigger.selectedOptionKey
            )
          : matchesType(column?.type, "ChoiceColumn") &&
            column.choiceAnswers?.some(
              (option) => (option?.key ?? (option as Option & { Key?: string })?.Key) === trigger.selectedOptionKey
            )
      );
    }) ?? false
  );
}
